[
  {
    "code": "LS-D",
    "name": "Berea"
  },
  {
    "code": "LS-B",
    "name": "Butha-Buthe"
  },
  {
    "code": "LS-C",
    "name": "Leribe"
  },
  {
    "code": "LS-E",
    "name": "Mafeteng"
  },
  {
    "code": "LS-A",
    "name": "Maseru"
  },
  {
    "code": "LS-F",
    "name": "Mohale's Hoek"
  },
  {
    "code": "LS-J",
    "name": "Mokhotlong"
  },
  {
    "code": "LS-H",
    "name": "Qacha's Nek"
  },
  {
    "code": "LS-G",
    "name": "Quthing"
  },
  {
    "code": "LS-K",
    "name": "Thaba-Tseka"
  }
]